var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGestaoAusencias(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gestao-ausencias",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gestao-ausencias_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.3,41.6h-4.9v-8.1h-8.1v8.1H58.7v-8.1h-8.1v8.1h-4.9c-6.7,0-12.2,5.5-12.2,12.2v71.5 c0,6.7,5.5,12.2,12.2,12.2h79.6c6.7,0,12.2-5.5,12.2-12.2V53.8C137.5,47.1,132,41.6,125.3,41.6z M45.7,49.8h4.9v8.1h8.1v-8.1h53.6 v8.1h8.1v-8.1h4.9c2.2,0,4.1,1.8,4.1,4.1v9.7H41.6v-9.7C41.6,51.6,43.4,49.8,45.7,49.8z M125.3,129.4H45.7c-2.2,0-4.1-1.8-4.1-4.1 V71.7h87.7v53.6C129.4,127.6,127.6,129.4,125.3,129.4z M48.3,101.7h22.3V79.4H48.3V101.7z M56.5,87.5h6.1v6.1h-6.1V87.5z  M115.4,92.6h-8.1v-8.1h8.1V92.6z M100.3,121h22.3V98.7h-22.3V121z M108.5,106.8h6.1v6.1h-6.1V106.8z M77,84.5h8.1v8.1H77V84.5z  M100.3,92.6h-8.1v-8.1h8.1V92.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestaoAusencias);
export default __webpack_public_path__ + "static/media/gestao-ausencias.7d71a2d799d16745d62a96bc7797c932.svg";
export { ForwardRef as ReactComponent };